export const CHARACTER_TYPES: Record<number, string> = {
  1: "Latin",
  2: "Cyrillic",
  3: "Hieroglyphs",
};

export const RULE_REPLACE_MAP: Record<string, string> = {
  // "  ": "<space><space>",
  " ": "&lt;space&gt;",
  "\n": "&#92;n",
  "\t": "&#92;t",
};
